import { render, staticRenderFns } from "./BackgroundMaker.vue?vue&type=template&id=35de8202&scoped=true"
import script from "./BackgroundMaker.vue?vue&type=script&lang=js"
export * from "./BackgroundMaker.vue?vue&type=script&lang=js"
import style0 from "./BackgroundMaker.vue?vue&type=style&index=0&id=35de8202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35de8202",
  null
  
)

export default component.exports